<template>
  <div class="start-last-service2">
      <button v-if="isWaiting" class="start-service disable">立即启动</button>
      <button v-else @click="startService()" class="start-service">立即启动</button>
  </div>
</template>

<script>
import * as api from '@/utils/api.js'
import { mapState, mapGetters } from 'vuex'
export default {
  name: 'StartLastService2',
  data () {
    return {
      lastService: null,
      isWaiting: true,
      timer: null
    }
  },
  computed: {
    ...mapState(['user']),
    ...mapGetters(['isLogin', 'isPC'])
  },
  async created () {
    this.$store.dispatch('init')
    await this.getLastService()
    this.isWaiting = false
  },
  mounted () {
    if (this.timer) {
      clearInterval(this.timer)
    } else {
      this.timer = setInterval(async () => {
        await this.getLastService()
        console.log(this.lastService)
      }, 1000 * 20)
    }
  },
  destroyed () {
    if (this.timer) {
      clearInterval(this.timer)
    }
  },
  methods: {
    async getLastService () {
      const serviceList = await api.getServiceList(this.user.id, this.user.jwt)
      this.lastService = serviceList[0]
    },
    async startService () {
      if (!this.isPC) {
        alert('请在PC电脑上进行操作!')
        return
      }
      if (!this.isLogin) {
        alert('请先登录再进行操作！')
        return
      }
      if (this.lastService.started !== 0) {
        alert('服务已启动，无需再次启动')
        return
      }
      const r = confirm(
        '请确认（1）这是您的个人电脑；（2）本次服务在此电脑部署云化环境并生成远程文件夹。'
      )
      if (r === false) return
      // 设置为等待
      this.isWaiting = true
      try {
        await api.startService(this.user.id, this.user.jwt, this.lastService.id)
        await this.getLastService()
      } catch (error) {
        console.log(error)
      }
      // 取消等待
      this.isWaiting = false
    }
  }
}
</script>

<style lang="scss" scoped>
.start-last-service2 {
  .start-service {
      background-color:rgb(52, 149, 238);
      color: rgb(255, 255, 255);
      border: 1px solid rgb(255, 255, 255);
      border-radius: 8px;
      font-size: 16px;
      font-family: 'Roboto';
      cursor: pointer;
      padding: 12px 20px;
      display: block;
      margin: 0 auto;
      outline: none;
      letter-spacing: 5px;
  }
  .disable {
    background-color: rgba(52,149,238,0.5);
    cursor: default;
  }
}
</style>
